import React from 'react';

import './LoginScreen.css';

import { Button, Loading, Icon } from 'carbon-components-react';
import { Locked32 } from '@carbon/icons-react';

import cwcLogoBlue from './cwc-logo-full-blue.png'

function LoginScreen( props ) {
  const { loginFx } = props // `user` can be added here as well
  // loading prop
  if (false) {
    return (
      <div id="loading-container">
        <Loading active={true} withOverlay={false} />
      </div>
    )
  }

  return (
    <div id="login-container">
      <img src={cwcLogoBlue} id="cwc-logo-login"/>
      <Button renderIcon={Locked32} id="login-button" onClick={() => loginFx()} >Authenticate</Button>
      <div id="spacer" />
    </div>
  );
}

export default LoginScreen;
